import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-masterpage',
  templateUrl: './masterpage.component.html',
  styleUrls: ['./masterpage.component.scss']
})
export class MasterpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
